import './AppLoader.less';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { motion } from 'motion/react';
import CloudAdminLogo from 'images/incorta-cloud-admin-logo.png';

const REVEAL = {
  duration: 0.16,
  delay: 0.12,
  ease: [0.22, 1, 0.36, 1] as const,
};

let hasRevealed = false;

export default function AppLoader() {
  return (
    <motion.div
      className="AppLoader"
      role="status"
      aria-label="Loading Incorta Cloud Admin"
      initial={hasRevealed ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={REVEAL}
      onAnimationComplete={() => {
        hasRevealed = true;
      }}
    >
      <img
        className="AppLoader__logo"
        src={CloudAdminLogo}
        alt="Incorta Cloud Admin"
        draggable={false}
      />
      <Spin
        indicator={<LoadingOutlined className="AppLoader__spinner" spin />}
      />
    </motion.div>
  );
}
